import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Halogen$dHTML$dProperties from "../Halogen.HTML.Properties/index.js";
import * as Halogen$dQuery$dInput from "../Halogen.Query.Input/index.js";
import * as Halogen$dVDom$dDOM$dProp from "../Halogen.VDom.DOM.Prop/index.js";
import * as Halogen$dVDom$dTypes from "../Halogen.VDom.Types/index.js";
const fa_ = s => Halogen$dVDom$dTypes.$VDom("Elem", Data$dMaybe.Nothing, "i", [Halogen$dHTML$dProperties.class_("fa-solid " + s)], []);
const fa = s => c => Halogen$dVDom$dTypes.$VDom("Elem", Data$dMaybe.Nothing, "i", [Halogen$dHTML$dProperties.classes(["fa-solid " + s, ...c])], []);
const empty = /* #__PURE__ */ Halogen$dVDom$dTypes.$VDom("Text", "");
const button = content => style => h => Halogen$dVDom$dTypes.$VDom(
  "Elem",
  Data$dMaybe.Nothing,
  "button",
  [
    Halogen$dHTML$dProperties.classes(["rounded w-full h-full py-1 px-2 transition-colors duration-75", style]),
    Halogen$dVDom$dDOM$dProp.$Prop("Handler", "click", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", h)))
  ],
  [content]
);
const downButton = /* #__PURE__ */ button(/* #__PURE__ */ Halogen$dVDom$dTypes.$VDom(
  "Elem",
  Data$dMaybe.Nothing,
  "i",
  [/* #__PURE__ */ Halogen$dHTML$dProperties.class_("fa-solid fa-angle-down")],
  []
))("text-gray-500 hover:bg-gray-200");
const plusButton = /* #__PURE__ */ button(/* #__PURE__ */ Halogen$dVDom$dTypes.$VDom(
  "Elem",
  Data$dMaybe.Nothing,
  "i",
  [/* #__PURE__ */ Halogen$dHTML$dProperties.class_("fa-solid fa-plus")],
  []
))("border border-sky-500 text-sky-700 hover:bg-sky-200");
const removeButton = /* #__PURE__ */ button(/* #__PURE__ */ Halogen$dVDom$dTypes.$VDom(
  "Elem",
  Data$dMaybe.Nothing,
  "i",
  [/* #__PURE__ */ Halogen$dHTML$dProperties.class_("fa-solid fa-xmark")],
  []
))("text-gray-500 hover:bg-gray-200");
const toggleButton = /* #__PURE__ */ button(/* #__PURE__ */ Halogen$dVDom$dTypes.$VDom(
  "Elem",
  Data$dMaybe.Nothing,
  "i",
  [/* #__PURE__ */ Halogen$dHTML$dProperties.class_("fa-solid fa-arrows-rotate")],
  []
))("text-gray-500 hover:bg-gray-200");
const upButton = /* #__PURE__ */ button(/* #__PURE__ */ Halogen$dVDom$dTypes.$VDom(
  "Elem",
  Data$dMaybe.Nothing,
  "i",
  [/* #__PURE__ */ Halogen$dHTML$dProperties.class_("fa-solid fa-angle-up")],
  []
))("text-gray-500 hover:bg-gray-200");
export {button, downButton, empty, fa, fa_, plusButton, removeButton, toggleButton, upButton};
